import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallOfferSuggestionComponent } from './components/call-offer-suggestion/call-offer-suggestion.component';
import { CallOfferListComponent } from './components/call-offer-list/call-offer-list.component';
import { ArchivedCallOfferComponent } from './components/archived-call-offer/archived-call-offer.component';
import { DetailsOfferComponent } from './components/details-offer/details-offer.component';
import { CandidatureCallOfferComponent } from './components/candidature-call-offer/candidature-call-offer.component';
import { DetailcandidaturecallofferComponent } from './components/detailcandidaturecalloffer/detailcandidaturecalloffer.component';
import { DetailsuggestionComponent } from './components/detailsuggestion/detailsuggestion/detailsuggestion.component';
import { ContactcallofferComponent } from './components/contactcalloffer/contactcalloffer.component';
import { esnAbonneNonabonneeGuard } from '@core/guards/esn-abonne-nonabonnee.guard';
import { esnAbonneeGuard } from '@core/guards/esn-abonnee.guard';
import { DossierCandidatureComponent } from './components/dossier-candidature/dossier-candidature.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'liste',
    pathMatch: 'full',
  },
  {
    path:'liste',
    component:CallOfferListComponent,
    // canActivate: [esnAbonneNonabonneeGuard.canActivate]
  },
  
  {
    path:'suggestions/:id',
    component:CallOfferSuggestionComponent,
    // canActivate: [esnAbonneeGuard.canActivate]
  },
  {
    path:'details-suggestion/:id',
    component:DetailsuggestionComponent,
  },
  {
    path:'archived',
    component:ArchivedCallOfferComponent,
    canActivate: [esnAbonneeGuard.canActivate]
  },
 
  {
    path:'details-offer/:id/:state',
    component:DetailsOfferComponent
  },
  {
    path:'details-offer/:id',
    component:DetailsOfferComponent,
    // canActivate: [esnAbonneNonabonneeGuard.canActivate]
  },
  {
    path:'candidature',
    component:CandidatureCallOfferComponent,
    canActivate: [esnAbonneeGuard.canActivate]
  },
  {
    path:'details-offer-candidature/:id/:userid',
    component:DetailcandidaturecallofferComponent
  },
  {
    path:'contact/:id',
    component:ContactcallofferComponent
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CallOfferRoutingModule { }
